<template>
  <div>
    <div class="common_bottom">
      <div>
        <div>
          <div>©2022 JoJoWorld. All Rights Reserved <span @click="toServer">Privacy Policy</span></div>
          <div>
            <img @click="toTwitter" src="../assets/icon_twitter.svg"/>
            <img @click="toTelegram" src="../assets/icon_telegram.svg"/>
          </div>
        </div>
        <div>
<!--          <div><img src="../assets/logo/googlecloud.png" /><img src="../assets/logo/METAMASK.png" /></div>-->
<!--          <div><img src="../assets/logo/nvidia.png" /><img src="../assets/logo/microsoft.svg" /></div>-->
          <div></div>
          <div><img src="../assets/logo/METAMASK.png" /><img src="../assets/logo/microsoft.svg" /></div>
          <div><img src="../assets/logo/bnbchain.svg" /><img src="../assets/logo/aws.svg" /></div>
          <div><img src="../assets/logo/unity.svg" /><img src="../assets/logo/tenity1.png" /></div>
          <div><img src="../assets/logo/hashkey.svg" /><img src="../assets/logo/stratified.png" /></div>
        </div>
      </div>
     </div>


     <div class="mobile_bottom">
        <img @click="toTwitter" src="../assets/icon_twitter.svg"/><img @click="toTelegram" src="../assets/icon_telegram.svg"/>
     </div>
  </div>
</template>

<script>
export default {
  name: 'Bottom',
  data () {
    return {
    }
  },
  mounted () {
  },
   components: {
  },
  methods: {
    toServer () {
      this.$router.push('/termsService')
    },
    toTwitter () {
      window.open('https://twitter.com/JoJoWorld2022')
    },
    toTelegram () {
      window.open('https://t.me/JoJoWorldofficial')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 767px) {
   .common_bottom {
     display:none;
   }
   .mobile_bottom {
     display:block;
   }
}
@media (min-width: 767px) {
   .common_bottom {
     display:block;
   }
   .mobile_bottom {
     display:none;
   }
}
.mobile_bottom {
  z-index:20;
  position:fixed;
  bottom:0px;
  width:100%;
  text-align: right;
  background: rgba(2, 2, 2, 0.70);
  img {
    width:26px;
    height:26px;
    margin-top:12px;
    margin-bottom:8px;
  }
  img:nth-child(2) {
    margin-right:40px;
    margin-left:26px;
  }

}
.common_bottom {
   width:100%;
   background: linear-gradient(270deg, #030504 0.01%, rgba(3, 5, 4, 0.00) 100.38%);
   position:fixed;
   bottom:0px;
   >div {
      padding:18px 0;
      display:flex;
      >div:nth-child(1){
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 20px;
        margin-left:8%;
        >div:nth-child(1) {
          color: var(--Shade-0, #FFF);
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px; /* 116.667% */
        }
        >div:nth-child(2) {
          >img {
            width: 26px;
            height: 26px;
            margin-right:28px;
          }
        }
      }
      >div:nth-child(2) {
        margin-left: auto;
        margin-right:8%;
        display: flex;
        height: 70px;
        align-items: center;
        gap: var(--Name-color, 50px);

        >div {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          align-self: stretch;
        }
        >div {
          width: 110px;
          img {
            width: 122px;
          }
        }
        >div:nth-child(4) {
          width:70px;
          img:nth-child(1) {
            width:78px;
          }
          img:nth-child(2) {
            width:78px;
          }
        }
        >div:nth-child(5) {
          width:100px;
          img:nth-child(1) {
            width:100px;
          }
          img:nth-child(2) {
            width:105px;
          }
        }
        //>div:nth-child(1) {
        //  width:122px;
        //  img:nth-child(1) {
        //    width:122px;
        //  }
        //  img:nth-child(2) {
        //    width:123px;
        //  }
        //}
        //>div:nth-child(2) {
        //  width:94px;
        //  img:nth-child(1) {
        //    width:94px;
        //  }
        //  img:nth-child(2) {
        //    width:92px;
        //  }
        //}
        //>div:nth-child(3) {
        //  width:120px;
        //  img:nth-child(1) {
        //    width:120px;
        //  }
        //  img:nth-child(2) {
        //    width:110px;
        //  }
        //}
        //>div:nth-child(4) {
        //  width:68px;
        //  img:nth-child(1) {
        //    width:68px;
        //  }
        //  img:nth-child(2) {
        //    width:64px;
        //  }
        //}
        //>div:nth-child(5) {
        //  width:68px;
        //  img:nth-child(1) {
        //    width:68px;
        //  }
        //  img:nth-child(2) {
        //    width:80px;
        //  }
        //}
      }
   }

}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue